import React, { ReactNode, useState } from 'react';

import { FancyRenderingContext } from './FancyRenderingContext';

export interface FancyRenderingContextType {
  fancyRendering: boolean;
  setFancyRendering: React.Dispatch<React.SetStateAction<boolean>>;
  enableMarkdownInTracing?: boolean;
}

interface FancyRenderingProviderProps {
  children: ReactNode;
  enableMarkdownInTracing?: boolean;
}

export function FancyRenderingProvider({
  children,
  enableMarkdownInTracing,
}: FancyRenderingProviderProps) {
  const [fancyRendering, setFancyRendering] = useState(true);

  return (
    <FancyRenderingContext.Provider
      value={{ fancyRendering, setFancyRendering, enableMarkdownInTracing }}
    >
      {children}
    </FancyRenderingContext.Provider>
  );
}
